<div class="flex w-full py-3.5 items-center px-6 title font-main text-3xl font-bold text-navy-90 border-b border-navy-30">
  {{ buildTranslationKey('legal') | translate }}
</div>

<div class="w-full h-full overflow-x-hidden overflow-y-auto pt-4 pb-6 px-6">
  <div class="flex w-full h-full flex-col gap-4 max-w-125">
    <div *ngVar="ndaFileName$ | async as ndaFileName" class="flex w-full flex-col gap-1">
      <div class="text-navy-90 font-bold text-base">
        {{ buildTranslationKey('nonDisclosureAgreement') | translate }}
        <span class="asterisk"></span>
      </div>

      <div class="text-navy-70 text-base">
        {{ buildTranslationKey('ndaWillBeSentToUsers') | translate }}
      </div>

      @if (ndaFileName) {
        <div class="flex gap-3 mt-4">
          <div class="p-2.5 border border-navy-60 rounded-md text-navy-90 text-base flex-1 h-10 whitespace-nowrap truncate" [title]="ndaFileName">
            {{ ndaFileName }}
          </div>

          <app-new-button
            class="h-10"
            [type]="'secondary'"
            [size]="'responsive'"
            [loading]="uploadingNda$ | async"
            [saveButtonSizeDuringLoading]="true"
            (click)="openNdaUpload()"
          >
            {{ buildTranslationKey('update') | translate }}
          </app-new-button>

          <app-icon-button
            [loading]="downloadingNda$ | async"
            [svgIconPath]="'download'"
            [type]="'secondary'"
            [iconSize]="'small'"
            (click)="downloadNda()"
          ></app-icon-button>
        </div>
      } @else {
        <div class="mt-4">
          <app-new-button
            class="h-10 w-full text-navy-70"
            [type]="'secondary'"
            [loading]="uploadingNda$ | async"
            (click)="openNdaUpload()"
          >
            {{ buildTranslationKey('selectFile') | translate }}
          </app-new-button>
        </div>
      }
    </div>

    <app-legal-settings-text-input
      [title]="buildTranslationKey('toWhichEmailToSendNda') | translate"
      [placeholder]="buildTranslationKey('toWhichEmailToSendNdaPlaceholder') | translate"
      [value]="emailsToSendNdas$ | async"
      [saveOnBlur]="false"
      [validators]="emailValidators"
      [errorText]="emailErrors"
      [submitHandlerFunction]="submitNdaEmailsCallback"
    />

    <div class="h-px w-full bg-navy-40"></div>

    <app-legal-settings-text-input
      [title]="buildTranslationKey('yourTos') | translate"
      [subtitle]="buildTranslationKey('yourTosDescription') | translate"
      [placeholder]="buildTranslationKey('linkPlaceholder') | translate"
      [value]="tosUrl$ | async"
      [saveOnBlur]="false"
      [validators]="termsOfServiceValidators"
      [errorText]="urlErrors"
      [submitHandlerFunction]="submitTosUrlCallback"
    />

    <div class="h-px w-full bg-navy-40"></div>

    <app-legal-settings-text-input
      [title]="buildTranslationKey('yourPrivacyPolicy') | translate"
      [subtitle]="buildTranslationKey('yourPrivacyPolicyDescription') | translate"
      [placeholder]="buildTranslationKey('linkPlaceholder') | translate"
      [value]="privacyPolicyUrl$ | async"
      [saveOnBlur]="false"
      [validators]="privacyPolicyValidators"
      [errorText]="urlErrors"
      [submitHandlerFunction]="submitPrivacyUrlCallback"
    />

    <div class="h-px w-full bg-navy-40"></div>

    <div class="flex w-full flex-col gap-4">
      <div class="flex text-navy-90 font-bold text-base">
        {{ buildTranslationKey('filesWatermark') | translate }}

        <svg-icon
          class="w-3.5 ml-1"
          [src]="'info-dark'"
          [ngbTooltip]="filesWatermarkTooltip"
          [tooltipClass]="'default-tooltip watermark-tooltip'"
          [placement]="'top'"
        />
      </div>

      <div class="flex items-center gap-x-3 cursor-pointer" role="button" (click)="updateWatermarkFlag(!hasWatermark)">
        <app-toggle [ngModel]="hasWatermark" (ngModelChange)="updateWatermarkFlag($event)"></app-toggle>
        <span class="text-navy-70 text-base">{{ buildTranslationKey('setWatermark') | translate }}</span>
      </div>
    </div>
  </div>
</div>

<ng-template #filesWatermarkTooltip>
  <span class="whitespace-pre-line" [innerHTML]="buildTranslationKey('filesWatermarkTooltip') | translate"></span>
</ng-template>
